import ProductsTable from '../../components/ProductsTable'
import BaseView from '../BaseView'

const Products = () => {
    return <BaseView title="Products" subviews={[<ProductsTable key={0} />]} />
}

export default Products
